/* hde-survol : au survol d'une vignette (ordinateur seulement), la vidéo du triptyque défile.
   Chargée au premier survol (preload none) : aucun poids au chargement de la page. Marine, 01/10/2026. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var st = document.createElement('style');
  st.textContent = '.media .hde-survol{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .35s ease;pointer-events:none;z-index:2}.media.hde-joue .hde-survol{opacity:1}';
  document.head.appendChild(st);
  document.addEventListener('mouseover', function (e) {
    var c = e.target.closest && e.target.closest('.card-wrapper');
    if (!c || c.__hde) return;
    var v = c.querySelector('video.hde-survol');
    if (!v) return;
    c.__hde = true;
    if (!v.getAttribute('src')) v.src = v.dataset.src;
    var m = v.closest('.media');
    var p = v.play();
    if (p && p.then) p.then(function () { if (c.__hde) m.classList.add('hde-joue'); }).catch(function () {});
    c.addEventListener('mouseleave', function f() {
      c.__hde = false; v.pause(); m.classList.remove('hde-joue'); c.removeEventListener('mouseleave', f);
    });
  });
})();
